import React, { useState, useEffect } from "react";

// Components
import Sidebar from "../../components/Sidebar";
import Topbar from "../../components/Topbar";
import Main from "./WarehouseItem/Main";

// Utils
import { getDataWithComp, getAlert } from "../../../utils/SamuiUtils";
import { InitialDataTbSetItem } from "../../../model/InitialData/InitialDataTbSetItem";

const WarehouseItem = () => {
  const [mode, setMode] = useState("");
  const [dataMasterList, setDataMasterList] = useState([]);
  const [selectedData, setSelectedData] = useState(null);
  const [formData, setFormData] = useState(InitialDataTbSetItem());
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    try {
      setMode("S");
      fetchRealtime();
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const fetchRealtime = async () => {
    try {
      // ดึงข้อมูลจาก View_Set_Item ทั้งหมด
      const masterList = await getDataWithComp(
        "View_Set_Item",
        "ORDER BY Item_Short_Name, Item_Brand, Item_Series, Item_Colour, Size_Line"
      );
      if (masterList && masterList.length > 0) {
        masterList.sort((a, b) => a.Emp_Id - b.Emp_Id);
        setDataMasterList(masterList);
      }
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const onPageInsert = () => {
    setMode("I");
  };

  const onRowSelected = (item) => {
    setMode("U");
    setFormData({
      item_id: item.Item_Id,
      comp_id: item.Comp_Id,
      item_barcode: item.Item_Barcode,
      item_code: item.Item_Code,
      item_name: item.Item_Name,
      item_name_en: item.Item_Name_EN,
      item_short_name: item.Item_Short_Name,
      item_unit_in: item.Item_Unit_IN,
      item_unit_st: item.Item_Unit_ST,
      item_unit_out: item.Item_Unit_OUT,
      item_cost: item.Item_Cost,
      item_price: item.Item_Price,
      item_pricea: item.Item_PriceA,
      item_priceb: item.Item_PriceB,
      item_brand: item.Item_Brand,
      item_series: item.Item_Series,
      item_group: item.Item_Group,
      item_cat: item.Item_Cat,
      item_colour: item.Item_Colour,
      item_size: item.Item_Size,
      item_status: item.Item_Status,
      item_popoint: item.Item_PoPoint,
      item_maxonhand: item.Item_MaxOnhand,
      ap_code: item.AP_Code,
      item_gold: item.Item_Gold,
      item_onhand: item.Item_Onhand,
      item_wh: item.WH_Name,
    });
    setSelectedData(item);
  };

  const breadcrumbs = [
    { label: "คลังสินค้า", link: "/warehouse" },
    { label: "รายการสินค้า", link: "/warehouse-item" },
  ];

  return (
    <div className="Creditor">
      <button
        onClick={() => setIsSidebarOpen(!isSidebarOpen)}
        className="btn btn-toggle-sidebar"
        style={{
          position: "fixed",
          top: "1rem",
          left: isSidebarOpen ? "190px" : "-15px",
          zIndex: 1001,
          background: "transparent",
          border: "none",
          color: "#E13F57",
          fontSize: "20px",
        }}
      >
        {isSidebarOpen ? "✖" : "☰"}
      </button>
      <div className="wrapper">
        <Sidebar
          isSidebarOpen={isSidebarOpen}
          setIsSidebarOpen={setIsSidebarOpen}
        />
        <div
          className={`main-panel ${
            isSidebarOpen ? "sidebar-open" : "sidebar-closed"
          }`}
        >
          <Topbar breadcrumbs={breadcrumbs} />
          <div className="container">
            <div className="page-inner" style={{ marginTop: "56px" }}>
              <Main
                masterList={dataMasterList}
                name={"รายการสินค้า"}
                onPageInsert={() => onPageInsert()}
                onRowSelected={(item) => onRowSelected(item)}
                initialize={initialize}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WarehouseItem;
